/* Dansk katalog for locale-sales-payments-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'inv.unknownAccount': 'Ukendt konto',
  'inv.refund.customerBalance': "Til gode hos os",
  'inv.refund.balanceHelp': "Saldoen omfatter kreditnotaerne og indbetalingerne og tilbagebetalingerne nedenfor.",
  'inv.refund.addFee': "Tilføj gebyr",
  'inv.refund.businessFee': "Gebyr betalt af virksomheden",
  'inv.refund.customerReceives': "Kunden modtager",
  'inv.refund.accountDebit': "Samlet træk på kontoen",
  'sale.pay.ownerDebt': "Kortfristet gæld til ejere",
  'sale.pay.title': 'Betaling',
  'sale.pay.help': 'Vælg, hvilken konto salget blev betalt til, og hvilken dato. Tilføj gebyr, eller del betalingen op i flere indbetalinger. Totalen skal stemme med salgslinjerne.',
  'sale.pay.paidTo': 'Betalt til',
  'sale.pay.choosePaymentAccount': 'Vælg betalingskonto',
  'sale.create.needPaymentAccount': 'Vælg Betalt til, før du registrerer salget.',
  'sale.pay.paidDate': 'Betalingsdato',
  'sale.pay.fee': 'Gebyr',
  'sale.pay.addFee': 'Tilføj gebyr',
  'sale.pay.removeFee': 'Fjern gebyr',
  'sale.pay.partial': 'Delbetalinger',
  'sale.pay.addPartial': 'Tilføj delbetaling',
  'sale.pay.removePartial': 'Fjern delbetaling',
  'sale.pay.seeTransaction': 'Se transaktion',
  'sale.pay.addAccount': 'Tilføj konto',
  'sale.pay.addCard': 'Tilføj kreditkort',
  'sale.pay.addBankTitle': 'Tilføj bankkonto',
  'sale.pay.addCardTitle': 'Tilføj kreditkort',
  'sale.pay.addSolutionTitle': 'Tilføj betalingsløsning',
  'sale.pay.solution': 'Betalingsløsning',
  'sale.pay.accountType': 'Kontotype',
  'sale.pay.cardOwner': 'Kortet tilhører',
  'sale.pay.displayName': 'Visningsnavn (valgfrit)',
  'sale.pay.orgNumber': 'Org.nummer',
  'sale.pay.openingBalance': 'Startsaldo til afstemning',
  'sale.pay.openingBalanceDate': 'Dato for startsaldo',
  'sale.pay.resetChoice': 'Nulstil valg',
  'sale.cust.helpTitle': 'Kunde på salget',
  'sale.cust.help': 'Her vælger du, hvem salget gælder. Søg en gemt kunde, liste eller abonnement frem — eller tryk på »Ny kunde« for at indtaste en modtager, der ikke er gemt i forvejen. Navn og adresse hentes automatisk ind på dokumentet.',
  'sale.cust.optionalHelp': 'Kunde er valgfrit ved andet salg. Slå til, hvis du vil knytte salget til en bestemt kunde.',
  'sale.cust.search': 'Søg i kunder, lister og abonnementer...',
  'sale.cust.pickExisting': 'Vælg eksisterende',
  'sale.cust.new': 'Ny kunde',
  'sale.cust.add': 'Tilføj kunde',
  'sale.cust.selected': 'Valgt kunde',
  'sale.cust.selectedList': 'Valgt modtagerliste',
  'sale.cust.none': 'Ingen kunde valgt endnu',
  'sale.cust.listsAndSubs': 'Lister og abonnementer',
  'sale.cust.detailsTitle': 'Kundeoplysninger',
  'sale.cust.name': 'Kundenavn',
  'sale.cust.namePh': 'F.eks. Eksempel AS',
  'sale.cust.number': 'Kundenr.',
  'sale.cust.org': 'Org.nr.',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Adresse',
  'sale.cust.addressPh': 'Gadeadresse, postnr. og by',
  'sale.cust.email': 'E-mail',
  'sale.cust.emailPh': 'post@eksempel.no',
  'sale.cust.phone': 'Telefon',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Kontaktpersoner',
  'sale.cust.noContacts': 'Ingen kontaktpersoner tilføjet.',
  'sale.cust.addContact': 'Tilføj kontaktperson',
  'sale.cust.removeContact': 'Fjern kontaktperson',
  'sale.cust.contactName': 'Navn',
  'sale.cust.contactNamePh': 'F.eks. Kari Nordmann',
  'sale.cust.contactRole': 'Rolle',
  'sale.cust.contactRolePh': 'F.eks. Regnskab',
  'sale.cust.outstanding': 'Udestående',
  'sale.cust.revenueToDate': 'Omsætning hidtil',
  'sale.cust.pickPh': 'Kunde eller nummer',
  'sale.cust.select': 'Vælg kunde',
  'sale.cust.use': 'Brug kunde',
  'sale.cust.noEmail': 'Ingen e-mail på kunden',
  'sale.cust.listDefaultName': 'Kundeliste',
  'sale.cust.updatedToast': 'Kunde opdateret i salget',
  'sale.cust.noCustomerHelp': 'Salget registreres uden kunde. Slå kontakten til, hvis du vil knytte det til en kunde.',
  'sale.cust.selectHint': 'Vælg en gemt kunde, liste eller abonnement - eller brug Ny kunde til fri indtastning.',
  'sale.cust.recipientsCount': '{count} modtagere',
  'sale.cust.kindSubscription': 'Abonnement',
  'sale.cust.kindList': 'Liste',
  'sale.cust.noMatches': 'Ingen resultater for »{query}«.',
  'sale.cust.addAsNew': 'Tilføj »{query}« som ny kunde',
  'sale.cust.contactDefaultName': 'Kontaktperson {n}',
  'sale.cust.saveFailed': 'Kunne ikke gemme kunden.',
  'sale.pay.accountNameSavings': 'Opsparingskonto',
  'sale.pay.accountNameOperating': 'Driftskonto',
  'sale.pay.accountNamePrivate': 'Privatkonto',
  'sale.pay.accountNameBank': 'Bankkonto',
  'sale.pay.groupBank': 'Bankkonti',
  'sale.pay.groupCard': 'Kreditkort',
  'sale.pay.groupPrivate': 'Privat',
  'sale.pay.groupOther': 'Andet',
  'sale.pay.groupGeneric': 'Konti',
  'sale.pay.cashLabel': 'Kontant',
  'sale.pay.bankNameRequired': 'Giv bankkontoen et navn',
  'sale.pay.accountOrCardNameRequired': 'Giv kontoen eller kortet et navn',
  'sale.pay.accountNumberRequired': 'Udfyld kontonummer',
  'sale.pay.bankAccountAdded': 'Bankkonto tilføjet',
  'sale.pay.privateAccountAdded': 'Privatkonto tilføjet',
  'sale.pay.saveAccountFailed': 'Kunne ikke gemme konto.',
  'sale.pay.accountsUnavailable': 'Betalingskonti er ikke koblet til backend.',
  'sale.pay.openingSetupRequired': 'Udfyld startdato og startsaldo. Skriv 0, hvis saldoen var nul.',
  'sale.pay.invalidLedgerAccount': 'Mangler gyldigt kontonummer i kontoplanen.',
  'sale.pay.accountExists': 'Konto {code} findes allerede.',
  'sale.pay.typePrivateCard': 'Privatkonto / kort',
  'sale.pay.newBankAccountNote': 'Ny bankkonto oprettes i kontoplanen',
  'sale.pay.newPrivateAccountNote': 'Ny privatkonto/kort oprettes i kontoplanen',
  'sale.pay.bankAccountSeriesInfo': 'Bankkonti får den næste ledige konto i 192x-serien.',
  'sale.pay.privateAccountSeriesInfo': 'Private kort/konti får den næste ledige mellemregningskonto i 206x-serien.',
  'sale.pay.thisGetsAccount': 'Denne får konto',
  'sale.pay.accountNameLabel': 'Kontonavn',
  'sale.pay.accountOrCardNameLabel': 'Navn på konto / kort',
  'sale.pay.accountNamePhBank': 'F.eks. Driftskonto 2',
  'sale.pay.accountNamePhPrivate': 'F.eks. Ejerkort Visa',
  'sale.pay.accountNumberLabel': 'Kontonummer',
  'sale.pay.accountCardRefLabel': 'Konto / kortnummer / reference (valgfrit)',
  'sale.pay.interimAccountPrefix': 'Mellemregning',
  'sale.pay.cardNameRequired': 'Giv kreditkortet et navn',
  'sale.pay.cardNumberRequired': 'Udfyld kort-/kontonummer',
  'sale.pay.openingBalanceRequired': 'Udfyld startsaldo og dato for startsaldo',
  'sale.pay.creditCardDebtPrefix': 'Kreditkortgæld',
  'sale.pay.cardAdded': 'Kreditkort tilføjet',
  'sale.pay.saveCardFailed': 'Kunne ikke gemme kreditkort.',
  'sale.pay.scopeBusiness': 'Virksomhed',
  'sale.pay.businessCardNote': 'Firmakort bogføres som separat kortgæld',
  'sale.pay.privateCardNote': 'Privat kort bogføres som mellemregning',
  'sale.pay.businessCardSeriesInfo': 'Firmakort, der ikke er bankkonto, får den næste ledige konto i 238x-serien.',
  'sale.pay.privateCardSeriesInfo': 'Private kort får den næste ledige mellemregningskonto i 206x-serien.',
  'sale.pay.accountInLedger': 'Konto i regnskabet:',
  'sale.pay.cardNamePhBusiness': 'F.eks. Firmakort Visa',
  'sale.pay.cardNamePhPrivate': 'F.eks. Ejerkort Mastercard',
  'sale.pay.cardNumberLabel': 'Kortnummer / kontonummer',
  'sale.pay.cardNumberLabelOptional': 'Kortnummer / kontonummer (valgfrit)',
  'sale.pay.otherSolution': 'Anden betalingsløsning',
  'sale.pay.settlementPrefix': 'Afregning',
  'sale.pay.solutionAdded': 'Betalingsløsning tilføjet',
  'sale.pay.saveSolutionFailed': 'Kunne ikke gemme betalingsløsning.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe og lignende bogføres på en separat afregningskonto for betalingsløsningen, som afstemmes, når afregningen er udbetalt til bankkontoen.',
  'sale.pay.addCardAction': '+ Tilføj kreditkort ...',
  'sale.pay.addSolutionAction': '+ Tilføj betalingsløsning ...',
  'sale.pay.partialLabel': 'Delbetaling {n}',
  'sale.pay.partialStatusRemaining': 'mangler',
  'sale.pay.partialStatusTooMuch': 'for meget',
  'sale.pay.partialStatusMatches': 'stemmer',
  'sale.pay.partialSummary': 'Betalt {paid} af {expected} · {status}',
  'sale.pay.partialMismatch': 'Summen af delbetalingerne skal stemme med salgstotalen{feeSuffix} ({expected}).',
  'sale.list.noMembers': 'Listen har ingen kunder at fakturere.',
  'sale.list.customerMissing': 'Kunden findes ikke længere.',
  'sale.list.noneCreated': 'Der blev ikke oprettet nogen fakturaer.',
  'sale.list.missingEmailNotice': '{count} fakturaer er oprettet til kunder uden e-mail og skal sendes eller udskrives manuelt: {names}',
  'sale.list.notCreatedNotice': 'Ikke fuldført for: {names}',
  'sale.list.createdNoEmail': 'Fakturaen er oprettet, men kunden mangler e-mail. Send eller udskriv den manuelt.',
  'sale.list.noneSent': 'Fakturaerne er oprettet, men ingen blev sendt på e-mail. Send eller udskriv manuelt: {names}',
  'sale.list.recipientsCount': '{count} modtagere',
  'sale.list.sentPartly': 'Sendt til {sent} modtagere. Ikke sendt: {names}',
  'sale.list.sentAll': 'Sendt til {sent} modtagere.',
  'sale.pay.partialMismatchFeeSuffix': ' minus gebyr',
  'sale.pay.feeTooHigh': 'Gebyret kan ikke være større end salget ({gross}).',
  'sale.pay.splitMismatchError': 'Delbetalingerne ({paid}) skal tilsammen stemme med salgstotalen minus gebyr ({expected}).',
  'sale.product.backendUnavailable': 'Produktlagring er ikke koblet til backend.',
  'sale.product.added': 'Produktet "{name}" er tilføjet',
  'sale.product.updated': 'Produktet "{name}" er opdateret',
  'sale.product.saveFailed': 'Kunne ikke gemme produktet.',
  'sale.create.backendUnavailable': 'Nyt salg er ikke koblet til backend.',
});
